export default theme => ({
  offlimits: {
    color: theme.palette.secondary.main,
  },
  icon_warning: {
    marginLeft: 10,
  },
});
